import React, { memo, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { TimelineInfo } from "../../models/Timeline";
import styles from "./TimelineTopPageSwiper.module.css";

interface TimelineTopPageSwiperProps {
    timelineList: TimelineInfo[];
    handleSlideGroupClick: (page: number) => void;
    currentTimeline: number;
}

function TimelineTopPageSwiper({
    timelineList,
    handleSlideGroupClick,
    currentTimeline,
}: TimelineTopPageSwiperProps) {
    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    // page数設定
    const [pageNum, setPageNum] = useState<number[]>([]);

    //page数設定
    useEffect(() => {
        const timelineLength = Math.ceil(timelineList.length / 10);
        const index: number[] = [];
        for (let i = 0; i < timelineLength; i++) {
            index.push(i + 1);
        }
        setPageNum(index);
    }, [timelineList]);

    return (
        <div className={styles.swiper}>
            <div
                ref={navigationPrevRef}
                style={{
                    position: "relative",
                    top: "6px",
                }}
            >
                <img
                    src={require("../../../assets/image/left2.svg")}
                    onMouseOver={(e) =>
                        (e.currentTarget.src = require("../../../assets/image/left2_hover.svg"))
                    }
                    onMouseOut={(e) =>
                        (e.currentTarget.src = require("../../../assets/image/left2.svg"))
                    }
                    alt="leftArrowIcon"
                />
            </div>
            <Swiper
                spaceBetween={5}
                slidesPerGroup={5}
                slidesPerView={5}
                className={styles.swiperContainer}
                navigation={{
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current,
                }}
            >
                {pageNum.map((page) => (
                    <SwiperSlide
                        key={page}
                        className={styles.slidePage}
                        onClick={() => {
                            handleSlideGroupClick(page);
                        }}
                    >
                        <div
                            style={{
                                color:
                                    currentTimeline === page
                                        ? "var(--white)"
                                        : "rgba(255,255,255,0.4)",
                            }}
                        >
                            {page}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div
                ref={navigationNextRef}
                style={{
                    position: "relative",
                    top: "6px",
                }}
            >
                <img
                    src={require("../../../assets/image/right2.svg")}
                    onMouseOver={(e) =>
                        (e.currentTarget.src = require("../../../assets/image/right2_hover.svg"))
                    }
                    onMouseOut={(e) =>
                        (e.currentTarget.src = require("../../../assets/image/right2.svg"))
                    }
                    alt="rightArrowIcon1"
                />
            </div>
        </div>
    );
}
export default memo(TimelineTopPageSwiper);
